import { useEffect, useState } from "react";

export const useWindow = () => {
  const [windowSize, setWindowSize] = useState();
  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return windowSize;
};

// how to use

// import { useWindow } from "./hooks/useWindow";
// const windowSize = useWindow();
// console.log(windowSize);
//windowSize > 768 ? <Desktop /> : <Mobile />;
